"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthLevel = void 0;
/**
 * Required authentication level for a method.
 */
var AuthLevel;
(function (AuthLevel) {
    /**
     * RESTRICTED - User is partially authenticated and may perform verification operations.
     */
    AuthLevel[AuthLevel["RESTRICTED"] = 0] = "RESTRICTED";
    /**
     * LOW - User is authenticated.
     */
    AuthLevel[AuthLevel["LOW"] = 1] = "LOW";
    /**
     * STRONG - User is strongly authenticated.
     */
    AuthLevel[AuthLevel["STRONG"] = 2] = "STRONG";
    AuthLevel[AuthLevel["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AuthLevel || (exports.AuthLevel = AuthLevel = {}));
//# sourceMappingURL=RpcMethodInfo.js.map